import * as React from "react";

import { SVGProps } from '../../types/svg';

const defaultSize = {
  width: 173,
  height: 193,
}

function SvgComponent({ style }: SVGProps) {
  return (
    <svg
      style={{
        ...defaultSize,
        ...style
      }}
      viewBox="0 0 173 193"
    >
      <defs>
        <style>{".prefix__a{fill:#0f426f}"}</style>
      </defs>
      <path
        className="prefix__a"
        d="M122.767 82.877a7.534 7.534 0 00-7.531-7.534h-77.6a7.534 7.534 0 100 15.069h77.6a7.534 7.534 0 007.531-7.535zM37.629 105.48a7.534 7.534 0 000 15.069H84.76a7.534 7.534 0 000-15.069z"
      />
      <path
        className="prefix__a"
        d="M55.335 177.809h-25.2a15.086 15.086 0 01-15.069-15.069V30.137a15.086 15.086 0 0115.071-15.068h92.63a15.086 15.086 0 0115.069 15.069v46.335a7.534 7.534 0 1015.069 0V30.137A30.171 30.171 0 00122.767 0h-92.63A30.171 30.171 0 000 30.137v132.6a30.171 30.171 0 0030.137 30.137h25.2a7.534 7.534 0 000-15.069z"
      />
      <path
        className="prefix__a"
        d="M166.247 109.086a22.626 22.626 0 00-31.959-.006l-41.363 41.271a7.536 7.536 0 00-1.887 3.144l-9.008 29.656a7.533 7.533 0 009.22 9.451l30.41-8.424a7.532 7.532 0 003.311-1.928l41.276-41.199a22.629 22.629 0 000-31.965zm-50.52 61.1l-15.3 4.238 4.477-14.74 27.91-27.849 10.657 10.657zm39.871-39.8l-1.46 1.457-10.655-10.655 1.455-1.452a7.535 7.535 0 0110.66 10.65zM115.236 45.206h-77.6a7.534 7.534 0 100 15.069h77.6a7.534 7.534 0 000-15.069z"
      />
    </svg>
  )
}

export default SvgComponent
